import React, { useEffect, useState } from "react";
import SectionTitle from "../../components/SectionTitle";
import SingleCourse from "../../components/Course/SingleCourse";
import axios from "axios";
import { SERVER_URL } from "../../api/url";

const Course = () => {
  const [loading, setLoading] = useState(false);
  const [coursesData, setCoursesData] = useState([]);
  const [filteredTypes, setFilteredTypes] = useState([]);
  const [categories, setCategories] = useState([]); 
  const [name,setName]=useState("")

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/about/view_category`);
      if (response.status === 200) {
        const cats = response.data?.data || [];
        setCategories(cats);
        
    const videoCategory = cats.find(
        (cat) => cat.name?.toLowerCase()?.includes("video")
      );
setName(videoCategory?.name)
        if (videoCategory) {
          fetchCourses(videoCategory.name); 
         
        } 
      }
    } catch (err) {
      fetchCourses("Video"); 
    }
  };

  const fetchCourses = async (categoryName) => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_URL}/course`, {
        params: {
          type: categoryName, 
          page: 1,
          limit: 100,
        },
      });

      const fetchedCourses = response.data?.data?.currentDatas || [];
      setCoursesData(fetchedCourses);

      const types = fetchedCourses
        .map((item) => item.type)
        .filter((value, index, self) => value && self.indexOf(value) === index);
      
      setFilteredTypes(types);
    } catch (err) {
      console.error("Error fetching courses:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderCourses = (type) => {
    return coursesData
      .filter((course) => course.type === type)
      .map((course, index) => (
        <div key={index} className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
          <SingleCourse course={course} name={name}/>
        </div>
      ));
  };

  return (
    <div className="popular__course__area pt---100 pb---100">
      <div className="container">
        {loading ? (
          <div className="text-center">Loading Courses...</div>
        ) : filteredTypes.length > 0 && (
          <>
            <SectionTitle Title="Video French Courses" />
            {filteredTypes.map((type, index) => (
              <div key={index} className="row mb-5">
                <div className="col-12">
                  <h3 className="subheading mb-4">{`${type} Courses`}</h3>
                </div>
                {renderCourses(type)}
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default Course;